<template>
  <div id="app">
    <!-- 导航区域 -->
    <!--    <LuffyHeader />-->

    <router-view v-if="isRouterAlive"></router-view>
    <!-- <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="(!$route.meta.keepAlive)&&isRouterAlive"></router-view> -->
    <div>
      <template>
        <el-backtop></el-backtop>
      </template>
    </div>
  </div>
</template>

<script>
import LuffyHeader from '@/components/Common/LuffyHeader'
export default {
  name: 'App',

  components: {
    // LuffyHeader
  },
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true
    }
  },
  methods: {

    reload() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  },
  '$route.path': function (newVal, oldVal) {
    console.log(newVal)

  },
  created() {

    // 在页面加载时读取localStorage
    if (localStorage.getItem('store')) {
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(localStorage.getItem('store'))))
    }
    // 在页面刷新时将store保存到localStorage里
    window.addEventListener('beforeunload', () => {
      localStorage.setItem('store', JSON.stringify(this.$store.state))
    })
  }
}
</script>

<style lang='less'>
//@import url(); 引入公共css类
  @import './style/common';
</style>



// WEBPACK FOOTER //
// src/App.vue